import { type TableCellProps, TableCellContentType } from "./tableCellTypes";

const validContentTypes = [TableCellContentType.TEXT, TableCellContentType.SVG, TableCellContentType.GROUP];

/**
 * Type guard to validate TableCellProps objects
 * This helps catch issues that type assertions might hide
 */
export function isValidTableCellProps(props: unknown): props is TableCellProps {
  if (!props || typeof props !== "object") {
    return false;
  }

  const cellProps = props as Record<string, unknown>;

  // Check if contentType exists and is valid
  if (!cellProps.contentType || typeof cellProps.contentType !== "string") {
    return false;
  }

  if (!validContentTypes.includes(cellProps.contentType as TableCellContentType)) {
    return false;
  }

  // Check if contents exists
  if (!cellProps.contents || typeof cellProps.contents !== "object") {
    return false;
  }

  return true;
}

/**
 * Validates and filters an array of TableCellProps, removing invalid ones
 * This helps catch issues that type assertions might hide
 */
export function validateTableCellPropsArray(cells: unknown[], context?: string): TableCellProps[] {
  const validCells: TableCellProps[] = [];
  const invalidCells: unknown[] = [];

  for (const cell of cells) {
    if (isValidTableCellProps(cell)) {
      validCells.push(cell);
    } else {
      invalidCells.push(cell);
    }
  }

  if (invalidCells.length > 0) {
    console.warn(`Found ${invalidCells.length} invalid table cells${context ? ` in ${context}` : ""}`, invalidCells);
  }

  return validCells;
}
